import React from "react";
//#region types
import { TitleIconProps } from "models/propTypes/commonPropTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
import Icon from "../icon";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";
import { CSSHelper } from "utils/helpers";

const TitleIcon: React.FC<TitleIconProps> = (props) => {
  return (
    <Grid item className={clsx(cssExports.titleIconContainer, CSSHelper.getClassByDisplayType(props.displayType))}>
      <Icon className={cssExports.titleIcon} icon={props.icon} />
    </Grid>
  );
};

export default TitleIcon;
